import React from 'react';

const StatusCard = ({ 
  title, 
  value, 
  icon, 
  status = 'default', 
  description = null, 
  action = null,
  className = '',
  gradient = false,
  size = 'default'
}) => {
  const statusStyles = {
    default: gradient ? 'bg-gradient-to-br from-white to-gray-50 border-gray-200' : 'bg-white border-gray-200',
    success: gradient ? 'bg-gradient-to-br from-green-50 to-emerald-50 border-green-200' : 'bg-green-50 border-green-200',
    warning: gradient ? 'bg-gradient-to-br from-yellow-50 to-orange-50 border-yellow-200' : 'bg-yellow-50 border-yellow-200',
    error: gradient ? 'bg-gradient-to-br from-red-50 to-pink-50 border-red-200' : 'bg-red-50 border-red-200',
    info: gradient ? 'bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-200' : 'bg-blue-50 border-blue-200',
  };

  const statusIconStyles = {
    default: 'text-gray-500',
    success: 'text-green-500',
    warning: 'text-yellow-500',
    error: 'text-red-500',
    info: 'text-blue-500',
  };

  const sizeStyles = {
    sm: 'p-4',
    default: 'p-6',
    lg: 'p-8'
  };

  const iconSizeStyles = {
    sm: 'text-xl',
    default: 'text-2xl',
    lg: 'text-3xl'
  };

  const valueSizeStyles = {
    sm: 'text-xl',
    default: 'text-2xl',
    lg: 'text-3xl'
  };

  return (
    <div className={`${sizeStyles[size]} border rounded-xl ${statusStyles[status]} ${className} hover:shadow-lg transition-all duration-300 hover:-translate-y-1 backdrop-blur-sm`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          {icon && (
            <div className={`${iconSizeStyles[size]} ${statusIconStyles[status]} transition-transform duration-300 hover:scale-110`}>
              {icon}
            </div>
          )}
          <div>
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            {description && (
              <p className="text-sm text-gray-600 leading-relaxed">{description}</p>
            )}
          </div>
        </div>
        
        <div className="text-right">
          <div className={`${valueSizeStyles[size]} font-bold text-gray-900`}>{value}</div>
          {action && (
            <div className="mt-2">
              {action}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatusCard;